/**
 * Sélecteur d'équivalence : off / normal / max / max+.
 */

export type EquivMode = 'off' | 'normal' | 'max' | 'maxplus';

const OPTIONS: { value: EquivMode; label: string; title: string }[] = [
  { value: 'off', label: 'off', title: 'Cartes exactes, pas de regroupement' },
  {
    value: 'normal',
    label: 'normal',
    title: 'Classes Type A/B ; bifurcations reportées si effet différé',
  },
  {
    value: 'max',
    label: 'max',
    title: 'Comme normal, mais masque les bifurcations (y compris reportées) entre cartes équivalentes — effet au pli réel',
  },
  {
    value: 'maxplus',
    label: 'max+',
    title: 'Comme max, et reporte aussi si bots différents au pli T dès que gagnant+points identiques et pli T+1 aligné',
  },
];

export function equivModeToGroupEquiv(mode: EquivMode): boolean {
  return mode !== 'off';
}

export default function DiffereStatsEquivModeToggle({
  value,
  onChange,
  disabled,
  showLowRankHint,
  lowRankLimit,
}: {
  value: EquivMode;
  onChange: (mode: EquivMode) => void;
  disabled?: boolean;
  showLowRankHint?: boolean;
  lowRankLimit?: number;
}) {
  return (
    <div className="differe-stats-equiv-mode" role="group" aria-label="Équivalence">
      <span className="differe-stats-equiv-mode-label">Équivalence</span>
      <div className="differe-stats-equiv-mode-track">
        {OPTIONS.map(opt => (
          <button
            key={opt.value}
            type="button"
            disabled={disabled}
            className={`differe-stats-equiv-mode-btn${value === opt.value ? ' is-active' : ''}`}
            title={opt.title}
            aria-pressed={value === opt.value}
            onClick={() => onChange(opt.value)}
          >
            {opt.label}
          </button>
        ))}
      </div>
      {showLowRankHint && value !== 'off' && lowRankLimit != null && (
        <span className="admin-muted differe-stats-equiv-mode-hint">lowRank≤{lowRankLimit}</span>
      )}
    </div>
  );
}
